import React from 'react'

/**
 *
 */
const Container = ({ children }) => <div>{children}</div>

/**
 *
 */
const PublishInfoShortLabel = ({ value }) => {
  return <div>{value}</div>
}

/**
 *
 */
const ProductCode = ({ value }) => {
  return <div>{value}</div>
}

/**
 *
 */
export const Content = ({ publishInfoShortLabel, productCode }) => (
  <Container>
    <PublishInfoShortLabel value={publishInfoShortLabel} />
    <ProductCode value={productCode} />
  </Container>
)
